import React, { useEffect, useState } from 'react';
import { FlameIcon } from './Icons';
export function UrgencyBar() {
  const [spotsLeft, setSpotsLeft] = useState(47);
  useEffect(() => {
    const decrementSpot = () => {
      setSpotsLeft(prev => {
        if (prev <= 3) return 3;
        return prev - 1;
      });
    };
    const scheduleNext = () => {
      const delay = Math.random() * 60000 + 30000;
      return setTimeout(() => {
        decrementSpot();
        timerRef = scheduleNext();
      }, delay);
    };
    let timerRef = scheduleNext();
    return () => clearTimeout(timerRef);
  }, []);
  return <div className="fixed top-0 left-0 right-0 z-50" style={{
    background: 'linear-gradient(135deg, #8b1a1a 0%, #c0392b 50%, #8b1a1a 100%)'
  }} role="banner" aria-label="Limited time offer" data-id="element-327">
      <div className="max-w-4xl mx-auto px-4 py-2.5 flex items-center justify-center gap-2 text-center" data-id="element-328">
        <FlameIcon className="w-4 h-4 text-yellow-400 flex-shrink-0 hidden sm:block" data-id="element-329" />
        <p className="text-xs sm:text-sm font-sans font-medium text-white/95 leading-snug" data-id="element-330">
          <span className="font-bold text-yellow-300" data-id="element-331">$20 OFF</span> for the
          next{' '}
          <span className="inline-block font-bold text-yellow-300 tabular-nums min-w-[1.5rem]" aria-live="polite" data-id="element-332">
            {spotsLeft}
          </span>{' '}
          people. Join <span className="font-semibold" data-id="element-333">5,000+</span> dog owners
          fighting back against the{' '}
          <span className="font-semibold italic" data-id="element-334">"Kibble Industry"</span>.
        </p>
        <FlameIcon className="w-4 h-4 text-yellow-400 flex-shrink-0 hidden sm:block" data-id="element-335" />
      </div>
    </div>;
}